

















import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Mixins
import Phone from '@/mixins/Phone'
import Errors from '@/mixins/Errors'

@Component
export default class DownloadAppPhoneInput extends Mixins(Phone, Errors) {
  phone: string = null
  loading = false

  @Getter('token') token

  async getSms() {
    try {
      this.loading = true
      const res = await this.$api.user.getAppSms(this.token, this.phone)
      this.$toast.open({
        message: this.$t('cta.header.notifications.content.download_app') as string,
        type: 'is-success',
        duration: 5000
      })
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.loading = false
    }
  }
}
